import _ from 'lodash'

export default class ShipmentUnit {
  id = 0
  shipmentStockId=null
  shipmentSize = null
  receiveDocument = null
  receiveDocumentDate = null
  receiverCustomer = null
  receiverCustomerId = null
  senderCustomer = null
  senderCustomerId = null
  unitWeightBrutto=null
  unitWeightNetto=null
  shipmentInfo = null
  shipmentInfo2 = null
  shipmentKind = null
  stockQuantity = 0
  transport=null
  quantity = 0
  marking = null
  lotNo = null

  constructor (data) {
    _.forEach(data, (value, field) => {
      if (this.hasOwnProperty(field)) {
        this[field] = value
      }
    })

    this.stockQuantity = parseInt(this.stockQuantity)
  }
}
